import React from "react";
import CommonDocuments from "../common/Documents";

const ClaimsDocuments = () => (
  <CommonDocuments type="claims" />
);

export default ClaimsDocuments;



// WEBPACK FOOTER //
// ./components/claim/Documents.js